// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-section[data-v-5b1567b4]{padding:0}.card-section.padded[data-v-5b1567b4]{padding:1rem}.card-section.padded+.padded[data-v-5b1567b4]{padding-top:0}.card-section.dark[data-v-5b1567b4]{background-color:#f8f6ef}.card-section.light[data-v-5b1567b4]{background-color:#fefbf2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
